export enum LoggerContext {
  Auth = 'auth',
  Lienholder = 'lienholder',
  RequestTracking = 'request-tracking',
  Router = 'router',
  UserStore = 'user-store',
}
